<template>
  <div>
    <admin-wrapper
      :straight-title="additionalModuleName"
      :module-enabler="moduleEnabler"
      :is-form-fetched="isFormFetched"
      :inputs="inputs"
      :has-buttons="false"
    >
      <template #formPrints.input>
        <v-col>
          <v-row no-gutters>
            <v-col>
              <v-row no-gutters align="center">
                <v-col cols="auto" class="font-weight-medium pr-2">
                  {{ $i18n.t('admin.formPrint.configuration') }}
                </v-col>
                <v-col cols="auto">
                  <base-rounded-button
                    icon="mdi-plus"
                    size="x-small"
                    color="success"
                    @click="toggleDialog({ type: 'input' })"
                  />
                </v-col>
                <v-spacer />
                <data-input v-model="searchValue" v-bind="searchInput" />
              </v-row>
            </v-col>
          </v-row>
          <form-print-list ref="form-print-list" @toggleDialog="toggleDialog($event)" :search-value="searchValue" />
        </v-col>
      </template>
    </admin-wrapper>
    <form-print-configuration
      v-if="isMainInputDialogLoaded"
      :is-visible.sync="isMainInputDialogVisible"
      :item="payload"
      :is-loading="isLoading"
      @onAgree="dialogActionHandler($event)"
      @onClose="toggleDialog($event)"
    />
    <main-dialog
      v-if="isMainDialogLoaded"
      :is-visible.sync="isMainDialogVisible"
      :title="$i18n.t('dialog.title.deleteFormPrint')"
      :body="
        $i18n.t('dialog.body.deleteFormPrintConfirmation', {
          name: payload.name,
        })
      "
      agree-text="dialog.agreeDelete"
      :loading="isLoading"
      @agree="dialogActionHandler({ type: 'delete' })"
      @modalClosed="toggleDialog({ value: false })"
    />
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
import FormPrintList from '@/components/FormPrintList';
import FormPrintConfiguration from '@/components/FormPrintConfiguration';

export default {
  name: 'FormPrintSettings',
  components: {
    AdminWrapper,
    DataInput,
    FormPrintList,
    FormPrintConfiguration,
    MainDialog: () => import('@/components/MainDialog'),
  },
  data: () => ({
    isMainDialogLoaded: false,
    isMainDialogVisible: false,
    isMainInputDialogLoaded: false,
    isMainInputDialogVisible: false,
    isLoading: false,
    isFormFetched: false,
    payload: {},
    searchValue: '',
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@FORM_PRINT.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@form_print_module_enabled'),
    moduleEnabler() {
      return {
        name: 'form_print_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    formPrints: get('formPrint/formPrints'),
    inputs() {
      return [{ name: 'formPrints', isNamedSlot: false }];
    },
    searchInput() {
      return {
        dataType: { name: 'text' },
        placeholder: this.$i18n.t('default.find'),
        appendIcon: 'mdi-magnify',
        hideDetails: true,
      };
    },
  },
  watch: {
    isModuleEnabled: {
      handler(nV) {
        if (nV) this.init();
        else this.isFormFetched = true;
      },
      immediate: true,
    },
  },
  methods: {
    ...call('formPrint/*FormPrin*'),
    getDataSources: call('layers/getLayersMetadata'),
    getProfiles: call('smartMatch/getProfiles'),
    toggleDialog({ type = '', value = true, item = null } = {}) {
      if (item) {
        const selectedItem = this.formPrints.find(form => form.id === item.id);
        this.payload = { ...selectedItem, ...selectedItem.settings };
        delete this.payload.settings;
      }
      if (!value) this.payload = {};
      this[`isMain${this.$_capitalize(type)}DialogLoaded`] = value;
      this[`isMain${this.$_capitalize(type)}DialogVisible`] = value;
    },
    dialogActionHandler({ type, settingsKeys }) {
      const dict = {
        add: () => this.addEditFormPrintHandler('add'),
        edit: () => this.addEditFormPrintHandler('edit', settingsKeys),
        delete: () => this.deleteFormPrintHandler(),
      };
      dict[type]();
    },
    async addEditFormPrintHandler(fn, settingsKeys = []) {
      this.isLoading = true;
      try {
        const { id, name, form, smart_match, layer, relation_attribute, layer_sm, ...settings } = this.payload;
        for (const setting in settings) {
          if (!settingsKeys.includes(setting) && fn === 'edit') delete settings[setting];
        }
        const payload = { id, name, form, smart_match, layer, relation_attribute, layer_sm, settings };
        await this[`${fn}FormPrint`](payload);
        this.$refs['form-print-list']?.search();
        this.toggleDialog({ type: 'input', value: false });
      } catch (error) {
        console.log('  error', error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteFormPrintHandler() {
      this.isLoading = true;
      try {
        await this.deleteFormPrint(this.payload.id);
        this.$refs['form-print-list']?.search();
        this.toggleDialog({ value: false });
        this.payload = {};
      } catch (error) {
        console.log('  error', error);
      } finally {
        this.isLoading = false;
      }
    },
    async init() {
      this.isFormFetched = false;
      await Promise.all([
        this.getDataSources({ with_attributes_schema: true }),
        this.getProfiles(),
        this.getFormPrints(),
        this.getFormPrintTemplates(),
      ]);
      this.isFormFetched = true;
    },
  },
};
</script>
